"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_commands_1 = require("prosemirror-commands");

var markInputRule_1 = __importDefault(require("../lib/markInputRule"));

var Mark_1 = __importDefault(require("./Mark"));

var Highlight = /*#__PURE__*/function (_Mark_1$default) {
  _inherits(Highlight, _Mark_1$default);

  var _super = _createSuper(Highlight);

  function Highlight() {
    _classCallCheck(this, Highlight);

    return _super.apply(this, arguments);
  }

  _createClass(Highlight, [{
    key: "inputRules",
    value: function inputRules(_ref) {
      var type = _ref.type;
      return [markInputRule_1.default(/(?:==)([^=]+)(?:==)$/, type)];
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        "Mod-Ctrl-h": prosemirror_commands_1.toggleMark(type)
      };
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        mark: "mark"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "mark";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        parseDOM: [{
          tag: "mark"
        }],
        toDOM: function toDOM() {
          return ["mark"];
        }
      };
    }
  }, {
    key: "toMarkdown",
    get: function get() {
      return {
        open: "==",
        close: "==",
        mixable: true,
        expelEnclosingWhitespace: true
      };
    }
  }]);

  return Highlight;
}(Mark_1.default);

exports.default = Highlight;